import { ChangeEventHandler, VFC } from "react";
import { NodeInstance } from "src/types/node.types";
import { Input } from "./fields/input";
import { FormField } from "./form-field";

export interface EditableNodeNameProps {
  node: NodeInstance;
  onChange: (node: NodeInstance) => void;
}

export const EditableNodeName: VFC<EditableNodeNameProps> = (props) => {
  const onChangeHandler: ChangeEventHandler<HTMLInputElement> = (e) => {
    props.onChange({ ...props.node, name: e.target.value });
  };

  return (
    <FormField.Field>
      <FormField.Label>Name</FormField.Label>
      <FormField.Input>
        <Input
          placeholder="Unnamed"
          value={props.node.name}
          onChange={onChangeHandler}
        />
      </FormField.Input>
    </FormField.Field>
  );
};
